module.exports = __webpack_public_path__ + "img/application_banner.fe75a6ff.png";